/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
// Import PolymerElement class
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { mixinBehaviors } from "@polymer/polymer/lib/legacy/class.js"; // define the element's class element

class profileContactDetailsEmailEdit extends mixinBehaviors([accessibilityBehaviours.commonFunctions, sbBehaviours.authAndSubmit, corpBehaviours.appCommonBehaviour], PolymerElement) {
  static get template() {
    return html`
         
        <style  include="app-styles">  
          .marginRight2{
            margin-right:2%;
          }
          .buttonPosition{
            position: absolute;
            align-content: center;
            bottom: 0;
            padding-bottom: 3%;
          }
          .buttonParent{
            position: relative;
          }
          .buttonHeight{
            // position: absolute;
            // bottom: 13%;
            // right: 9%;
            position: relative;
            margin-top: 75%;
          }
          oe-input{
          --paper-input-container-ms-clear: {
              color: white;
              height: 0;
              width: 0;
            }
          }
        </style>
        <app-media-query phone={{phone}} tablet={{tablet}} desktop={{desktop}}></app-media-query>
        <div class="mdl-grid mdl-grid--no-spacing" hidden$={{phone}}>
          <div class="mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col content-align-left text-align-left">
            <div hidden$="{{displayIcon(leftAction.leftIcon)}}">
              <a href="{{leftAction.lefthref}}" tabIndex="-1" hidden$="{{leftAction.leftCallback}}">
                <paper-icon-button icon="{{leftAction.leftIcon}}" class="action-btn-rtl"></paper-icon-button>
              </a>
              <div hidden$="{{!leftAction.leftCallback}}">
                <paper-icon-button id="email__back_button" aria-label$="{{getLabel('b_Back')}}" icon="{{leftAction.leftIcon}}" on-tap="_confirmBack"  aria-label$="{{getLabel('l_Back')}}" role="button" class="action-btn-rtl"></paper-icon-button>
              </div>
            </div>
          </div>
          <div class="outlineOffset mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet mdl-cell--6-col content-align-center text-align-center title-dark" tabindex=0 id="email_edit_page_title">
            <oe-i18n-msg msgid="{{titlePage}}"></oe-i18n-msg>
          </div>
        </div>
        <div class="mdl-grid buttonParent">
          <div class="margin-b-zero mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col">
            <oe-input wide-layout$="{{tablet}}" extra-wide-layout$="{{desktop}}" id='email_id' value={{selectedEmailDetails.emailId}}
              label="{{selectedEmailDetails.editLabel}}"></oe-input>
          </div>
          <template is="dom-if" if="{{selectedEmailDetails.alwaysPreferred}}">
            <div class="content-align-vertical-center full-width margin-l-zero mdl-grid">
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-disabled="true" aria-checked="false" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked marginRight2" hidden={{selectedEmailDetails.preferredContact}} on-tap="_checkUncheckPreference" ></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-disabled="true" aria-checked="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-unchecked marginRight2" hidden={{!selectedEmailDetails.preferredContact}} on-tap="_checkUncheckPreference"></iron-icon>
              <oe-i18n-msg class="font-size-m" msgid="l_setAsPreferedEmail"></oe-i18n-msg>
              </div>
          </template>
          <template is="dom-if" if="{{!selectedEmailDetails.alwaysPreferred}}">
            <template is="dom-if" if="{{selectedEmailDetails.isContactPresent}}">
              <div class="content-align-vertical-center full-width margin-l-zero mdl-grid">
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="false" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked cursor-pointer marginRight2" hidden={{selectedEmailDetails.preferredContact}} on-tap="_checkUncheckPreference" ></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-checked cursor-pointer text-brand-color marginRight2" hidden={{!selectedEmailDetails.preferredContact}} on-tap="_checkUncheckPreference"></iron-icon>
                  <oe-i18n-msg class="font-size-m" msgid="l_setAsPreferedEmail"></oe-i18n-msg>
              </div>
            </template>
            <template is="dom-if" if="{{!selectedEmailDetails.isContactPresent}}">
              <div class="content-align-vertical-center full-width margin-l-zero mdl-grid">
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="false" aria-disabled="true" aria-labelledby="{{getLabel('l_unselected')}}" id="unchecked_icon" icon="radio-button-unchecked" class="outlineOffset circle-unchecked marginRight2" hidden={{selectedEmailDetails.preferredContact}} on-tap="_checkUncheckPreference"></iron-icon>
                  <iron-icon tabindex="0" role="checkbox" type="checkbox" aria-checked="true" aria-disabled="true" aria-labelledby="{{getLabel('m_selected')}}" id="checked_icon" icon="check-circle" class="outlineOffset circle-unchecked marginRight2" hidden={{!selectedEmailDetails.preferredContact}} on-tap="_checkUncheckPreference"></iron-icon>
                  <oe-i18n-msg class="font-size-m disabled-dark-color" msgid="l_setAsPreferedEmail"></oe-i18n-msg>
              </div>
            </template>
          </template>
        </div>
        <template is="dom-if" if="{{phone}}">
          <div class="mdl-grid">
            <div class="buttonPosition mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col text-align-center">
              <paper-button id="email_update_btn" on-keydown = "setFocus" on-tap="_updateEmail" class="primary-button">
                <oe-i18n-msg msgid="b_Update" class="style-scope"></oe-i18n-msg>
              </paper-button>
            </div>
          </div>
        </template>
        <template is="dom-if" if="{{!phone}}">
          <div class="mdl-grid buttonHeight">
            <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col text-align-center">
              <paper-button id="email_update_btn" on-keydown = "setFocus" on-tap="_updateEmail" class="primary-button">
                <oe-i18n-msg msgid="b_Update" class="style-scope"></oe-i18n-msg>
              </paper-button>
            </div>
          </div>
        </template>
        <!-- app dialog for authorization i.e. transaction  password -->
 
        <app-dialog name="h_Authorization" id="emailUpdateAuthorization" elementid="emailUpdateAuthorization">
          <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
                <fin-auth-element-wrapper id="loan_acct_email_form_authPaymentStopWrapper" auth-method="{{authMethods}}"></fin-auth-element-wrapper>
              </div>
              <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                <paper-button id="submitLoanEmailFormAuthsubmit" on-tap="_continueToConfirm" on-keypress="_continueToConfirm" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_Submit"></oe-i18n-msg>
                </paper-button>
              </div>
          </div>
        </app-dialog>
          
        <app-dialog id="backNagigationPopup" closevisible="{{closevisible}}" elementid="backNagigationPopup">
          <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
              <oe-i18n-msg msgid="m_backNavigationError" class="font-size-m"></oe-i18n-msg>
              </div>
              <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                <paper-button id="submitLoanEmailFormAuthsubmit" on-tap="_leftAction" on-keypress="_leftAction" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_Yes"></oe-i18n-msg>
                </paper-button>
                <paper-button id="submitLoanEmailFormAuthsubmit" on-tap="_cancelBack" on-keypress="_cancelBack" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_No"></oe-i18n-msg>
                </paper-button>
              </div>
          </div>
        </app-dialog>
          `;
  }

  static get properties() {
    return {
      //To store page title
      titlePage: {
        type: String,
        notify: true
      },
      //Iron page selector for pages in profile-main
      myprofilepagenumber: {
        type: Number,
        notify: true,
        observer: 'resetAuth'
      },
      //Details of the selected email
      selectedEmailDetails: {
        type: Object,
        notify: true
      },
      //To store authentication methods
      authMethods: {
        type: Array,
        notify: true
      },
      //To store all the address and contact details
      commDetails: {
        type: Array,
        notify: true
      },
      //To hide close button from back navigation popup
      closevisible: {
        type: Boolean,
        value: false
      },
      fromEmailEditPage: {
        type: Boolean,
        value: false,
        notify: true,
      },
      personalDetailsResponse: {
        type: Array,
        notify: true
      }
    };
  }

  static get observers() {
    return ['emailChanged(selectedEmailDetails.emailId)'];
  }

  //To reset authmethods
  resetAuth(n) {
    if (n == 11) this.authMethods = [];
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('iron-overlay-closed', this._clearAuthMethods);
  }
  _clearAuthMethods() {
    this.authMethods = [];
  }

  //Called when email is changed
  emailChanged(email) {
    if (email == "" || email == undefined) {
      this.set('selectedEmailDetails.isContactPresent', false);
    } else {
      this.set('selectedEmailDetails.isContactPresent', true);
    }
  }

  //To check if user has changed the values
  _confirmBack() {
    if (this.selectedEmailDetails.originalEmail == this.selectedEmailDetails.emailId && this.selectedEmailDetails.tempFlag == true) {
      this.myprofilepagenumber = 8;
    } else {
      this.$.backNagigationPopup.$$("#backNagigationPopup").open();
    }
  }

  //cancel back navigation
  _cancelBack() {
    this.$.backNagigationPopup.$$("#backNagigationPopup").close();
  }

  //to navigate back
  _leftAction() {
    this.$.backNagigationPopup.$$("#backNagigationPopup").close();
    this.$$("#email_id").invalid = false;
    this.myprofilepagenumber = 8;
  } //To display the back icon


  displayIcon(value) {
    if (value == "") return true;
    return false;
  } //To set the preferred type


  _checkUncheckPreference() {
    var self = this;
    if (this.selectedEmailDetails.preferredcmCode != this.selectedEmailDetails.cmCode) {
      if (this.selectedEmailDetails.isContactPresent) {
        if (this.selectedEmailDetails.preferredContact) {
          this.set('selectedEmailDetails.preferredContact', false);
          this.selectedEmailDetails.tempFlag = !this.selectedEmailDetails.tempFlag;
          setTimeout(function () { self.shadowRoot.querySelector('#unchecked_icon').focus(); }, 500);
        } else {
          this.set('selectedEmailDetails.preferredContact', true);
          this.selectedEmailDetails.tempFlag = !this.selectedEmailDetails.tempFlag;
          setTimeout(function () { self.shadowRoot.querySelector('#checked_icon').focus(); }, 500);
        }
      }
    }
  } //Validates and calls the post api


  _updateEmail() {
    if (this.selectedEmailDetails.emailId.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
      this.$$("#email_id").invalid = false;

      if (this.authMethods == undefined || this.authMethods && this.authMethods.length == 0) {
        this.authMethods = [];
        this.header = [];
      }
      var self = this;
      var preferredContact = ""; // var contactDetails = {};

      if (self.commDetails[0].contactDetails) {
        for (let i = 0; i < self.commDetails[0].contactDetails.length; i++) {
          if (self.commDetails[0].contactDetails[i].contactType.codeType == "PFML") {
            if (self.commDetails[0].contactDetails[i].contactType.cmCode == this.selectedEmailDetails.cmCode) {
              var contactDetails = self.commDetails[0].contactDetails[i];
              var contactId = self.commDetails[0].contactDetails[i].contactId;
            }
            if (self.selectedEmailDetails.preferredContact == true) preferredContact = self.selectedEmailDetails.cmCode; else if (self.selectedEmailDetails.preferredContact == false) preferredContact = ""; else if (self.commDetails[0].contactDetails[i].preferredContact.cmCode == "Y") preferredContact = self.commDetails[0].contactDetails[i].contactType.cmCode;
          }
        }
      }

      var ajaxCall = document.createElement('oe-ajax');
      ajaxCall.contentType = "application/json";
      ajaxCall.handleAs = "json";
      ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/contactdetailsrequests';
      ajaxCall.method = 'POST';
      ajaxCall.body = {}
      ajaxCall.body["customerId"] = clientStorage.get(storageType.session, 'customerId');
	  if(!self.commDetails[0].contactDetails && preferredContact==""){
        ajaxCall.body["preferredEmail"] = self.selectedEmailDetails.cmCode;
	  }
	  else{
		ajaxCall.body["preferredEmail"] =preferredContact;
	  }
      ajaxCall.body["preferredEmail"] = preferredContact;
      ajaxCall.body[self.selectedEmailDetails.cType] = {}
      ajaxCall.body[self.selectedEmailDetails.cType]["id"] = contactId;
      ajaxCall.body[self.selectedEmailDetails.cType]["email"] = self.selectedEmailDetails.emailId;
      oeAjaxEventListner(ajaxCall);
      this.submitDetails(ajaxCall.url, ajaxCall.method, ajaxCall.body, this.header);
    } else {
      this.$$("#email_id").invalid = true;
      this.fire('oe-show-error', {
        message: getLabel('m_emailIdError')
      });
    }
  }

  //To open auth page to enter Txn password
  _callAuthPage() {
    this.$.emailUpdateAuthorization.$$("#emailUpdateAuthorization").open();
  }

  //To display success toast
  _callSucessPage(e) {
    this.$.emailUpdateAuthorization.$$("#emailUpdateAuthorization").close();
    this.myprofilepagenumber = 8;
    var successMsg;
    if (this.selectedEmailDetails.updateScenario) {
      successMsg = getLabel('l_emailWasUpdatedSuccessfully')
    } else {
      successMsg = getLabel('l_emailWasAddedSuccessfully')
    }
    this.fire('oe-show-success', {
      message: successMsg
    });
    this.fromEmailEditPage = true;
  } //To set the auth methods

  //To set the auth methods
  _continueToConfirm() {
    if (this.authenticationValidation(this.authMethods)) return;
    if (this.authMethods && this.authMethods.length == 1) this.header.primaryAccessCode = this.authMethods[0].wrapperValue;

    if (this.authMethods && this.authMethods.length == 2) {
      this.header.primaryAccessCode = this.authMethods[0].wrapperValue;
      this.header.secondaryAccessCode = this.authMethods[1].wrapperValue;
    }

    this._updateEmail();
  }

  //Manulayy Focused on Header
  _focusOnTitle() {
    setTimeout(function () {
      this.$$("#email_edit_page_title").setAttribute("tabindex", "0");
      this.$$("#email_edit_page_title").focus();
    }.bind(this), 0);
  }
  setFocus(event) {
    if (!event.shiftKey && (event.keyCode === 9 || KeyboardEvent.charCode == 9 || KeyboardEvent.keyCode == 9 || event.which == 9)) {
      this.shadowRoot.querySelector("#email_edit_page_title").focus();
    }
  }
} // Associate the new class with an element name


customElements.define('profile-contact-details-email-edit', profileContactDetailsEmailEdit);